module.exports = __webpack_public_path__ + "img/input-latin-uppercase.b19cdd8d.png";